import { render, staticRenderFns } from "./ProdutorModule.vue?vue&type=template&id=38df1a5c"
import script from "./ProdutorModule.vue?vue&type=script&lang=js"
export * from "./ProdutorModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports